<template>
  <button @click="params.callback(params.data.id)" class="btn btn-accent">
    {{ params.text }}
  </button>
</template>
